// extracted by mini-css-extract-plugin
export default {"container":"TariffLimitGroup_container__CJ-tD","title":"TariffLimitGroup_title__npOkw"};